//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from "moment";
export default {
  name: "FactorGroupModal",
  data: function data() {
    return {
      title: "操作",
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        code: {
          rules: [{
            required: true,
            message: '请输入编号!'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        },
        sort: {
          rules: [{
            required: true,
            message: '请输入排序号!'
          }]
        }
      },
      url: {
        add: "/site/factor/group/add",
        edit: "/site/factor/group/edit"
      }
    };
  },
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'code', 'title', 'status', 'sort', 'remark', 'createBy', 'createTime', 'updateBy', 'updateTime', 'tenantId')); //时间格式化


        _this.form.setFieldsValue({
          createTime: _this.model.createTime ? moment(_this.model.createTime) : null
        });

        _this.form.setFieldsValue({
          updateTime: _this.model.updateTime ? moment(_this.model.updateTime) : null
        });
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this2.model.id) {
            httpurl += _this2.url.add;
            method = 'post';
          } else {
            httpurl += _this2.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this2.model, values); //时间格式化

          formData.createTime = formData.createTime ? formData.createTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.updateTime = formData.updateTime ? formData.updateTime.format('YYYY-MM-DD HH:mm:ss') : null;
          console.log(formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};